import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import LiveKitClassroom from "./classroom/LiveKitClassroom";
import { MANAGEMENT_ROLES, normalizeRole, ROLE_TEACHER } from "../utils/authRole";
import HostWaitingRoomControls from "./tuition/HostWaitingRoomControls";

export default function ClassroomMeetingPage({ userRole }) {
  const { roomCode } = useParams();
  const navigate = useNavigate();
  const normalizedRole = normalizeRole(userRole);
  const isTeacher = normalizedRole === ROLE_TEACHER;
  const isHost = isTeacher || MANAGEMENT_ROLES.includes(normalizedRole);
  const rawName = localStorage.getItem("currentUserName") || (isTeacher ? "Teacher" : "Student");
  const displayName = rawName.includes("@")
    ? rawName.split("@")[0].replace(/[._-]+/g, " ")
    : rawName;

  return (
    <main className="min-h-screen bg-slate-950 p-3 text-white sm:p-6 relative flex flex-col">
      <div className="mx-auto max-w-7xl w-full flex-1 flex flex-col">
        <div className="mb-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-sky-300">Live classroom</p>
          <h1 className="mt-1 text-xl font-semibold">Room {roomCode}</h1>
        </div>
        <div className="flex-1 min-h-[500px] rounded-2xl overflow-hidden border border-slate-800 bg-slate-900 flex flex-col">
          <LiveKitClassroom
            meetingCode={roomCode}
            isHost={isHost}
            displayName={displayName}
            onLeave={() => navigate(isTeacher ? "/teacher-dashboard" : "/user-dashboard")}
          />
        </div>
      </div>

      {/* Floating Host Controls for Waiting Room Admission */}
      {isHost && <HostWaitingRoomControls roomCode={roomCode} isHost={true} />}
    </main>
  );
}
